const API_URL = import.meta.env.VITE_ADMIN_URL || "";

export async function getEmpleados(sucursal) {
  const res = await fetch(`${API_URL}/admin/empleados?sucursal=${sucursal}`);
  if (!res.ok) return [];
  const data = await res.json();
  return data.empleados || [];
}

export async function getEmpleadosContacto(sucursal, cliente) {
  // Ya no usamos composite key, cliente es el ID directo
  const res = await fetch(`${API_URL}/admin/cliente/${cliente}/empleados-contacto`);
  if (!res.ok) return [];
  const data = await res.json();
  return data.empleados || [];
}

export async function asignarEmpleadosContacto(sucursal, cliente, empleados) {
  // Ya no usamos composite key, cliente es el ID directo
  await fetch(`${API_URL}/admin/cliente/${cliente}/empleados-contacto`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ empleados })
  });
}

export async function eliminarEmpleadoContacto(sucursal, cliente, empleadoId) {
  // Ya no usamos composite key, cliente es el ID directo
  await fetch(`${API_URL}/admin/cliente/${cliente}/empleados-contacto/${empleadoId}`, {
    method: 'DELETE'
  });
}
